/**
 * Step-specific prompts for the contextual floating card.
 *
 * Maps each V2 funnel step to a short German question that Klara displays
 * to nudge the user into the chat.
 */

export const ANFRAGE_STEP_PROMPTS: Record<string, string> = {
  location: "Hilfe beim Standort?",
  // Keyed by the step's own name (`bedarf`, see QuickRequestV2's STEPS): under the old key
  // `quantity` this prompt never matched and every buyer saw the generic fallback instead.
  // Buyers on Step 2 mostly second-guess the price (quantity is typically given by their
  // UNB/planner — see the field hint) — put price first and keep Menge as the secondary
  // uncertainty.
  bedarf: "Unsicher bei Preis oder Menge?",
  contact: "Noch Fragen vor dem Absenden?",
};

export const ANGEBOT_STEP_PROMPTS: Record<string, string> = {
  location: "Hilfe beim Standort?",
  offer: "Fragen zu Ihrem Angebot?",
  contact: "Noch Fragen vor dem Absenden?",
};
